import axios from 'axios'
import * as _ from 'lodash'
import { withQuery, camalize, capitalize } from './'


const mapboxOptions = {
    api: "https://api.mapbox.com/geocoding/v5",
}

export const stateFromAddress = async (token: string, address: string, convertToCamalize: boolean = false): Promise<any> => {
    if (address == '' || !token || token == '') return null
    const query = {
        access_token: token
    }
    const url = `${mapboxOptions.api}/mapbox.places/${address}.json`
    let response = await axios.get(withQuery(url, query)).then((res) => {
        if (res.data && res.data.features && res.data.features) {
            let va = res.data.features[0].context.map((el, index) => {
                if (el.id.includes('region')) {
                    return convertToCamalize ? capitalize(camalize(el.text)) : el.text
                }
            }).filter(item => {
                return item != null
            })[0]
            return va
        }
    }).catch(err => {
        console.log('RDFE: ', err)
        return ''
    })

    return response
}

export const explodeAddress = async (token : string, address : string, convertToCamalize : boolean = false) : Promise<any> => {
    if(address == '' || !token || token == '') return null
    const query = {
        access_token: token
    }
    const url = `${mapboxOptions.api}/mapbox.places/${address}.json`
    let response = await axios.get(withQuery(url, query)).then((res) => {
        if (res.data && res.data.features && res.data.features) {
            let va = res.data.features[0].context.map((el, index) => {
                if (el.id.includes('region')) {
                    return convertToCamalize ? capitalize(camalize(el.text)) : el.text
                }
            }).filter(item => {
                return item != null
            })[0]
            return va
        }
    }).catch(err => {
        console.log('RDFE: ', err)
        return ''
    })

    return response
}